import { Button } from "@components/Button/Button";
import { RenderImg } from "@components/RenderIcon/RenderImg";
import HoorayIcon from "@assets/images/Hooray.svg";
import { useTranslation } from "react-i18next";
import { Wrapper, InfoWrapper, IconWrapper, ButtonWrapper } from "./component";
import { TopicStyle, DescStyle } from "./style";
import { onPostMsgToGrab } from "./functional";
import liff from "@line/liff";
import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { DebugPage, getFromLS } from "@utils";

export const UnLinkSuccessPage: React.FC = () => {
  const { t, i18n } = useTranslation();
  const [queryParameters] = useSearchParams();

  const langParam = queryParameters.get("lang");

  useEffect(() => {
    if (langParam !== null) {
      i18n.changeLanguage(langParam, (err) => {
        if (!err) {
          localStorage.setItem("preferredLanguage", langParam);
        }
      });
    }
  }, [langParam]);

  return (
    <Wrapper>
      <DebugPage>
        <div className="text-black">{`current language : ${i18n.language}`}</div>
        <div className="text-black">{`from local storage : ${getFromLS(
          "preferredLanguage"
        )}`}</div>
      </DebugPage>
      <IconWrapper>
        <RenderImg
          src={HoorayIcon}
          alt="hooray"
          width={"70%"}
          height={"auto"}
        />
      </IconWrapper>
      <InfoWrapper>
        <TopicStyle className="text-center">
          {t("status.unlink.success.topic")}
        </TopicStyle>
        <DescStyle className="text-center">
          {t("status.unlink.success.desc")}
        </DescStyle>
        <ButtonWrapper>
          <Button
            variant="success"
            onClick={() => {
              liff.closeWindow();
              onPostMsgToGrab({
                msg: "SUCCESS:UNLINK_SUCCESS",
              });
            }}>
            {t("button.close")}
          </Button>
        </ButtonWrapper>
      </InfoWrapper>
    </Wrapper>
  );
};
